document.addEventListener('DOMContentLoaded', function() {
  initFilterCheckboxes();
  initPriceApply();
  initSortSelect();
  initFilterModal();
  initDropdownOutsideClick();
});

function initFilterCheckboxes() {
  document.querySelectorAll('[data-filter-checkbox]').forEach(function(checkbox) {
    checkbox.addEventListener('change', function() {
      var url = this.checked ? this.dataset.urlAdd : this.dataset.urlRemove;
      if (url) window.location.href = url;
    });
  });
}

function initPriceApply() {
  document.querySelectorAll('[data-price-apply]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var panel = this.closest('.collection__filter-panel');
      var inputs = panel.querySelectorAll('[data-price-input]');
      var url = new URL(window.location.href);
      url.searchParams.delete('page');
      inputs.forEach(function(input) {
        if (input.value !== '') {
          url.searchParams.set(input.name, input.value);
        } else {
          url.searchParams.delete(input.name);
        }
      });
      window.location.href = url.toString();
    });
  });
}

function initSortSelect() {
  document.querySelectorAll('[data-collection-sort]').forEach(function(select) {
    select.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
}

function initFilterModal() {
  var modal = document.querySelector('[data-filter-modal]');
  if (!modal) return;

  document.querySelectorAll('[data-filter-content]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  });

  document.querySelectorAll('[data-filter-open]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
    });
  });

  document.querySelectorAll('[data-filter-close]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      modal.hidden = true;
      document.body.style.overflow = '';
    });
  });

  modal.addEventListener('click', function() {
    modal.hidden = true;
    document.body.style.overflow = '';
  });

  var form = modal.querySelector('[data-filter-form]');
  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var formData = new FormData(form);
      var params = new URLSearchParams();
      for (var pair of formData.entries()) {
        if (pair[1] !== '') {
          params.append(pair[0], pair[1]);
        }
      }
      var target = form.action;
      if (params.toString()) {
        target += '?' + params.toString();
      }
      window.location.href = target;
    });
  }
}

function initDropdownOutsideClick() {
  document.addEventListener('click', function(e) {
    document.querySelectorAll('[data-filter-dropdown][open]').forEach(function(details) {
      if (!details.contains(e.target)) {
        details.removeAttribute('open');
      }
    });
  });
}
